module.exports = __webpack_public_path__ + "static/media/m5.ccaafb11.jpg";